import React, { Component} from "react";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";
import {Footer, Header, FAQ, LastSection, Content} from "../components";
import {stepThreeItemsIcon} from "../images";
import { STEP_TWO_URL } from "../constants/path";

class SidebarPage extends Component{
	constructor(props) {
		super(props);
		this.state = {
			items: '',
			id: props.match.params,
			faqIds: ''
		};
	}
	handleClick() {
		// this.setState({id});
		// this.forceUpdate();
	}
	componentDidMount() {
		const that = this;
		window.scrollTo(0,0);
		axios.get(STEP_TWO_URL)
			.then(resulte => {
				// return resulte.json();
				return resulte.data;
			}).then(data => {
				let myarray = [];
				let faqids = '';
			for (let key in data) {
				if (key === this.state.id.name) {
					let items = data[key].map((items) => {
					return (
						<div key={items.id + 1}>
							<li className="" style={{marginRight: "102px"}} key={items.id}>
								<ul className="list-unstyled p-0 m-0" style={{display: "inline-flex"}}>
									<li className="list-inline-item p-0 m-0 pt-1"></li>
									<li className="list-inline-item p-0 m-0" style={{width: "165px"}}>
										<div className="sidebar-item-cat-title">{items.title}</div>
									</li>
								</ul>
							</li>
							{items.data.map((subItems) => {
								let classname = "sidebar-item-cat-item";
								let img = '';
								let customStyle = {marginRight: "102px"};
								if(parseInt(subItems.id) === parseInt(this.props.match.params.id)) {
									faqids = subItems.faqIds;
									classname = "sidebar-item-cat-item-active";
									document.title = subItems.text;
									that.setState({activeItem: subItems.text});
									img = <img style={{display: "inline", verticalAlign: "middle"}} className="pl-2" src={stepThreeItemsIcon} alt={items.title}/>
									customStyle = {};
								}
								return (
									<li className={`mb-1`} style={ customStyle } key={subItems.id}>
										<ul className="list-unstyled p-0 m-0" style={{display: "inline-flex"}}>
											<li className="list-inline-item p-0 m-0 pt-1">{img}</li>
											<li className="list-inline-item p-0 m-0" style={{width: "165px"}}>
												<Link target={"_self"} to={{ pathname: `${subItems.link}${items.link}/${subItems.text.split(" ").join("-")}/${subItems.id}` }} onClick={this.handleClick} className={classname}>{subItems.text}</Link>
											</li>
										</ul>
									</li>
								);
							})}
						</div>
					);
				});
				myarray.push(items);
				}
			}
			this.setState({items: myarray, faqIds: faqids});
		});
	}

	render () {
		return(
			<div className="smart-phone-container">
				<Header />

				<div className="container-fluid m-0 p-0">
					<div className="row p-0 m-0">

						<div className="col-12 mb-5 pb-5 sidebar-page-main-container">
							<div className="row direction-rtl">
								<div className="p-0 sidebar-border-left sidebar border-primary text-right" style={{width: "283px"}}>
									<ul className="list-unstyled">
										{ this.state.items }
									</ul>
								</div>
								<div className="col-9 step-three-content-container">
									<Content contentid={ this.state.id } video={{show: true, src: "video/src/foo"}} image={{show: true, src: "img/src/foo"}} />
									<FAQ title="پرسش های متداول" clsName={"faq-detail-page-text-color"} borderRight={true} />
									{/* <FAQ title="مقالات مرتبط" clsName={"faq-detail-page-text-color"} borderRight={true} ids={this.state.faqIds} /> */}
								</div>
							</div>
						</div>

					</div>
				</div>

				{/*<ThumbsUp/>*/}
				<LastSection/>
				<Footer />
			</div>
		);
	}
}

export default withRouter(SidebarPage);